var render = function render(){var _vm=this,_c=_vm._self._c;return (this.isArray)?_c('el-row',_vm._l((_vm.value),function(item){return _c('el-col',{key:item,attrs:{"span":6}},[_c('div',{staticClass:"grid-content"},[_c('form-result-value-display',{attrs:{"value":item}})],1)])}),1):_c('form-result-value-display',{attrs:{"value":_vm.value}})
}
var staticRenderFns = []

export { render, staticRenderFns }